import React, { useEffect, useState } from 'react';
import { Table, Pagination, Loader } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { API, showError, timestamp2string } from '../helpers';
import PageSizeSelectV8, { readPageSizeV8 } from './PageSizeSelectV8';

const LoginHistoryTable = () => {
  const { t } = useTranslation();
  const [histories, setHistories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(() =>
    readPageSizeV8('v8-page-size-login-history', 10)
  );

  const loadHistories = async (startIdx) => {
    setLoading(true);
    const res = await API.get(
      `/api/user/login_history?p=${startIdx}&page_size=${pageSize}`
    );
    const { success, message, data } = res.data;
    if (success) {
      if (startIdx === 0) {
        setHistories(data);
      } else {
        let newHistories = [...histories];
        newHistories.splice(startIdx * pageSize, data.length, ...data);
        setHistories(newHistories);
      }
    } else {
      showError(message);
    }
    setLoading(false);
  };

  const onPaginationChange = (e, { activePage }) => {
    (async () => {
      if (activePage === Math.ceil(histories.length / pageSize) + 1) {
        // In this case we have to load more data and then append them.
        await loadHistories(activePage - 1);
      }
      setActivePage(activePage);
    })();
  };

  useEffect(() => {
    loadHistories(0);
  }, [pageSize]);

  const handlePageSizeChange = (nextPageSize) => {
    setActivePage(1);
    setPageSize(nextPageSize);
  };

  return (
    <>
      <div
        className='management-table-scroll-v72'
        role='region'
        aria-label='Scrollable data table'
        tabIndex={0}
      >
        <Table
          basic
          unstackable
          className='management-table-v72 management-login-history-table-v72'
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>时间</Table.HeaderCell>
              <Table.HeaderCell>IP 地址</Table.HeaderCell>
              <Table.HeaderCell>设备/来源</Table.HeaderCell>
              <Table.HeaderCell>状态</Table.HeaderCell>
              <Table.HeaderCell>结果信息</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {histories
              .slice((activePage - 1) * pageSize, activePage * pageSize)
              .map((history, idx) => {
                if (!history) return null;
                return (
                  <Table.Row key={history.id}>
                    <Table.Cell>
                      {timestamp2string(
                        new Date(history.created_at).getTime() / 1000
                      )}
                    </Table.Cell>
                    <Table.Cell>{history.ip}</Table.Cell>
                    <Table.Cell>{history.device}</Table.Cell>
                    <Table.Cell
                      style={{ color: history.success ? 'green' : 'red' }}
                    >
                      {history.success ? '成功' : '失败'}
                    </Table.Cell>
                    <Table.Cell>{history.message}</Table.Cell>
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <div className='list-pagination-v8'>
        <PageSizeSelectV8
          label={t('log.table.page_size')}
          storageKey='v8-page-size-login-history'
          value={pageSize}
          onChange={handlePageSizeChange}
        />
        <Pagination
          activePage={activePage}
          onPageChange={onPaginationChange}
          size='small'
          siblingRange={1}
          totalPages={
            Math.ceil(histories.length / pageSize) +
            (histories.length % pageSize === 0 ? 1 : 0)
          }
        />
      </div>
    </>
  );
};

export default LoginHistoryTable;
